/**
 * This is essentially the public interface for the JavaScript.
 * Anything exported from this file will be publicly available
 */
import "./index.scss";
import Form from "./Form";
import ready from "./helpers/ready";

/**
 *
 * @type {Map<HTMLElement, Form>}
 */
const forms = new Map();

/**
 * Either create or return an existing instance of the `FEUForm` for the `form`.
 * @param {HTMLElement} form
 * @returns {Form|null} `null` if an error occurred during instantiation of the `FEUForm`.
 */
const init = form => {
    // exit early if this form has been initialized previously
    if ( forms.has( form ) )
        return forms.get( form );

    let wrapped = null;
    try {
        wrapped = new Form( form );
    } catch(err) {
        console.error( err );
    }
    forms.set( form, wrapped );
    return wrapped;
};

ready( () => {
    document.querySelectorAll( ".fg-feu-form" ).forEach( form => {
        init( form );
    } );
} );
